import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>(
    'div',
    'dropdownDisclaimerWrapper',
    'dropdown'
)`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    flex: '1 0 auto',
    display: 'inline-block',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Dropdown/StyledComponents/DropdownDisclaimerWrapper.tsx